import * as common from '../../common'

/**
 * The BCH LOC Population source document bundle:
 * - `glReport`: the current period's `chglr008` general ledger extract
 * - `awardType`: the `CH_GM_AWARD_NUM_TYPE_PROJECT` award type query
 * - `priorCashDraw`: the prior period's cash draw workbook, with its `LOC` tab
 */
export type Files = common.SourceFiles<
  'glReport' | 'awardType' | 'priorCashDraw'
>
export namespace Files {
  export const isFiles = common.SourceFiles.checker([
    'glReport',
    'awardType',
    'priorCashDraw',
  ])
}
